import { ModuleWithProviders, NgModule } from '@angular/core';
import { InlineSVGConfig } from './inline-svg.config';
import { InlineSVGDirective } from './inline-svg.directive';

@NgModule({
  declarations: [InlineSVGDirective],
  exports: [InlineSVGDirective],
})
export class InlineSVGModule {
  static forRoot(config?: InlineSVGConfig): ModuleWithProviders<InlineSVGModule> {
    return {
      ngModule: InlineSVGModule,
      providers: [{ provide: InlineSVGConfig, useValue: config }],
    };
  }
}
